import { render, staticRenderFns } from "./page-slogan.vue?vue&type=template&id=49d05013"
import script from "./page-slogan.vue?vue&type=script&lang=js"
export * from "./page-slogan.vue?vue&type=script&lang=js"
import style0 from "./page-slogan.vue?vue&type=style&index=0&id=49d05013&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports